var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29283 14.0508V15.7425C9.29283 17.1758 7.95949 18.3341 6.31782 18.3341C4.67615 18.3341 3.33447 17.1758 3.33447 15.7425V14.0508C3.33447 15.4841 4.66782 16.5008 6.31782 16.5008C7.95949 16.5008 9.29283 15.4758 9.29283 14.0508Z",
    stroke: "#007928",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29135 11.7591C9.29135 12.1758 9.17468 12.5591 8.97468 12.8924C8.48301 13.7007 7.47467 14.2091 6.308 14.2091C5.14134 14.2091 4.13299 13.6924 3.64133 12.8924C3.44133 12.5591 3.32471 12.1758 3.32471 11.7591C3.32471 11.0424 3.65802 10.4008 4.19136 9.93409C4.73302 9.45909 5.47466 9.17578 6.29966 9.17578C7.12466 9.17578 7.86635 9.46743 8.40802 9.93409C8.95802 10.3924 9.29135 11.0424 9.29135 11.7591Z",
    stroke: "#007928",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29283 11.7596V14.0513C9.29283 15.4846 7.95949 16.5013 6.31782 16.5013C4.67615 16.5013 3.33447 15.4763 3.33447 14.0513V11.7596C3.33447 10.3263 4.66782 9.16797 6.31782 9.16797C7.14282 9.16797 7.88451 9.45961 8.42618 9.92628C8.95951 10.3929 9.29283 11.043 9.29283 11.7596Z",
    stroke: "#007928",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6664 9.13903V10.8557C18.6664 11.3141 18.2997 11.689 17.833 11.7057H16.1997C15.2997 11.7057 14.4747 11.0474 14.3997 10.1474C14.3497 9.62238 14.5497 9.13071 14.8997 8.78904C15.208 8.47238 15.633 8.28906 16.0997 8.28906H17.833C18.2997 8.30573 18.6664 8.68069 18.6664 9.13903Z",
    stroke: "#007928",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99951 8.7513V7.08464C1.99951 4.81797 3.36618 3.23463 5.49118 2.96797C5.70785 2.93463 5.93284 2.91797 6.16618 2.91797H13.6662C13.8828 2.91797 14.0912 2.92629 14.2912 2.95963C16.4412 3.20963 17.8328 4.8013 17.8328 7.08464V8.29298H16.0995C15.6328 8.29298 15.2078 8.47629 14.8995 8.79296C14.5495 9.13463 14.3495 9.6263 14.3995 10.1513C14.4745 11.0513 15.2995 11.7096 16.1995 11.7096H17.8328V12.918C17.8328 15.418 16.1662 17.0846 13.6662 17.0846H11.5828",
    stroke: "#007928",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletMoney);
export default __webpack_public_path__ + "static/media/wallet-money.55e4eef44daf8d75081b654ddbec688e.svg";
export { ForwardRef as ReactComponent };